import { useTranslation } from 'react-i18next';
import '~/i18n';
export const useAppTrans = () => 
/** @ts-expect-error WHY：升上去nextjs@12, react@18 後壞了，暫不知何解 */
useTranslation();
